import React, { FunctionComponent, useEffect } from "react";
import { FieldValues, useFieldArray, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { getRackDetail, updateRackDetail } from "../../services";
import { UpdateRackInput } from "../../types/api";
import { RackForm } from "./form";

export const RackDetailWithID: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { register, handleSubmit, control, setValue } = useForm();
  const { fields, append, swap, remove } = useFieldArray({
    name: "image_url",
    control
  });
  const { id } = useParams();
  useEffect(() => {
    getRackDetail({ id, append, setValue, dispatch });
  }, [id, append, setValue, dispatch]);

  const onSubmit = async (data: FieldValues) => {
    const rackData: UpdateRackInput = {
      id: data.id,
      name: data.name,
      description: data.description,
      price: data.price,
      image_url: data.image_url
    };
    updateRackDetail({ dispatch, rackData });
  };

  return (
    <RackForm
      onSubmit={onSubmit}
      register={register}
      handleSubmit={handleSubmit}
      image_field={fields}
      image_append={append}
      image_swap={swap}
      image_remove={remove}
      created
    />
  );
};
